<template>
  <div class="flex gap-[12px]">
    <!--    <div-->
    <!--      class="overline-1 text-white bg-infra-highlight-500 rounded-[2px] px-[4px] py-[3px]">-->
    <!--      Default-->
    <!--    </div>-->
    <img src="@/assets/svg/enlarge.svg" alt="enlarge" />
  </div>
</template>
